export default "__VITE_ASSET__dad6aaf7__"